export enum AddScheduleTabs {
  GENERAL,
  SCHEDULE,
  MATCHING_CRITERIA
}
